var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 170,
    viewBox: "0 0 190 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13781",
    "data-name": "Group 13781",
    transform: "translate(-189.5 -768.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_17427",
    "data-name": "Path 17427",
    transform: "translate(206 805.225)",
    fill: "#ebebeb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 133.0364532470703 132.0205993652344 L 23.47700881958008 132.0205993652344 C 20.37122917175293 132.0205993652344 17.35884857177734 131.4485473632812 14.52356910705566 130.3203277587891 C 11.78660869598389 129.2312469482422 9.32896900177002 127.672492980957 7.218869209289551 125.6873550415039 C 5.110929012298584 123.7042541503906 3.456329107284546 121.3957290649414 2.300989151000977 118.8259506225586 C 1.110763072967529 116.178596496582 0.5049008727073669 113.3670196533203 0.5000389814376831 110.4689025878906 L 16.08548927307129 0.5000120401382446 L 140.4279937744141 0.5000120401382446 L 156.0134429931641 110.4689025878906 C 156.0085754394531 113.3670196533203 155.4027099609375 116.178596496582 154.2124938964844 118.8259506225586 C 153.0571441650391 121.3957290649414 151.4025268554688 123.7042541503906 149.2946166992188 125.6873550415039 C 147.1845092773438 127.672492980957 144.7268524169922 129.2312469482422 141.9899139404297 130.3203277587891 C 139.1546325683594 131.4485473632812 136.1422424316406 132.0205993652344 133.0364532470703 132.0205993652344 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.51960754394531 0.9999847412109375 L 1.000106811523438 110.5034332275391 C 1.00970458984375 113.318229675293 1.600662231445312 116.0489654541016 2.756988525390625 118.6209335327148 C 3.885223388671875 121.1304092407227 5.501693725585938 123.3853759765625 7.56146240234375 125.3231735229492 C 9.62554931640625 127.2650299072266 12.0301513671875 128.7900085449219 14.70840454101562 129.8557586669922 C 17.48463439941406 130.96044921875 20.434814453125 131.5205688476562 23.47700500488281 131.5205688476562 L 133.0364227294922 131.5205688476562 C 136.0786285400391 131.5205688476562 139.02880859375 130.96044921875 141.8050231933594 129.8557586669922 C 144.4832916259766 128.7900085449219 146.8878936767578 127.2650299072266 148.9519653320312 125.3231735229492 C 151.0117492675781 123.3853759765625 152.6282043457031 121.1304092407227 153.7564544677734 118.6209335327148 C 154.9127807617188 116.0489654541016 155.5037384033203 113.318229675293 155.5133361816406 110.5034332275391 L 139.9938507080078 0.9999847412109375 L 16.51960754394531 0.9999847412109375 M 15.65135192871094 -1.52587890625e-05 L 140.8621063232422 -1.52587890625e-05 L 156.5134429931641 110.4338073730469 C 156.5134429931641 122.6320114135742 146.0024261474609 132.5205688476562 133.0364227294922 132.5205688476562 L 23.47700500488281 132.5205688476562 C 10.51100158691406 132.5205688476562 -1.52587890625e-05 122.6320114135742 -1.52587890625e-05 110.4338073730469 L 15.65135192871094 -1.52587890625e-05 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17428",
    "data-name": "Path 17428",
    d: "M-.438,47.3C-.468,36.407-4.274-7.014,27.533-7.014S55.412,34.35,55.519,47.3",
    transform: "translate(256.724 776.439)",
    fill: "rgba(0,0,0,0)",
    stroke: "#262626",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16769",
    "data-name": "Group 16769",
    transform: "translate(301.412 842.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20989",
    "data-name": "Path 20989",
    d: "M0,0S7.522,6.786,15.029,6.786,30.031,0,30.031,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20996",
    "data-name": "Path 20996",
    d: "M0,2.661,2.091,0",
    transform: "translate(0.19 1.901)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20995",
    "data-name": "Path 20995",
    d: "M0,3.8,1.9,0",
    transform: "translate(4.373 4.372)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20994",
    "data-name": "Path 20994",
    d: "M0,4.562.95,0",
    transform: "translate(9.5 6.082)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20993",
    "data-name": "Path 20993",
    d: "M0,5.132V0",
    transform: "translate(15.013 6.843)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20990",
    "data-name": "Path 20990",
    d: "M.564,3.325l-.9-4.687",
    transform: "translate(20.039 7.375)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20992",
    "data-name": "Path 20992",
    d: "M1.711,3.991,0,0",
    transform: "translate(23.948 4.182)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20991",
    "data-name": "Path 20991",
    d: "M2.281,2.851,0,0",
    transform: "translate(27.746 1.711)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16770",
    "data-name": "Group 16770",
    transform: "translate(238.209 842.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20989-2",
    "data-name": "Path 20989",
    d: "M0,0S7.522,6.786,15.029,6.786,30.031,0,30.031,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20996-2",
    "data-name": "Path 20996",
    d: "M0,2.661,2.091,0",
    transform: "translate(0.19 1.901)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20995-2",
    "data-name": "Path 20995",
    d: "M0,3.8,1.9,0",
    transform: "translate(4.373 4.372)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20994-2",
    "data-name": "Path 20994",
    d: "M0,4.562.95,0",
    transform: "translate(9.5 6.082)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20993-2",
    "data-name": "Path 20993",
    d: "M0,5.132V0",
    transform: "translate(15.013 6.843)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20990-2",
    "data-name": "Path 20990",
    d: "M.564,3.325l-.9-4.687",
    transform: "translate(20.039 7.375)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20992-2",
    "data-name": "Path 20992",
    d: "M1.711,3.991,0,0",
    transform: "translate(23.948 4.182)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20991-2",
    "data-name": "Path 20991",
    d: "M2.281,2.851,0,0",
    transform: "translate(27.746 1.711)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21053",
    "data-name": "Path 21053",
    d: "M0,2.271s8.7-4.6,16.6-4.6,15,4.6,15,4.6",
    transform: "translate(269.811 894.778)",
    fill: "none",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21054",
    "data-name": "Path 21054",
    d: "M0,0H190",
    transform: "translate(189.5 937.926)",
    fill: "none",
    stroke: "#262626",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.1ab57a1a4718cfc74c6d0bd524d08323.svg";
export { ForwardRef as ReactComponent };